import { createContext } from 'react'

export const Context = createContext<{ isHead: boolean }>({ isHead: false })
